import { useI18n } from '@catawiki/cata-style';
import { getRFC4646Locale, isRFC4646Locale, RFC4646Locale, } from '@catawiki/locale';
export const useLocale = () => {
    const i18n = useI18n();
    const locale = isRFC4646Locale(i18n.locale)
        ? i18n.locale
        : getRFC4646Locale(i18n.locale);
    return locale || RFC4646Locale.ENGLISH;
};
//# sourceMappingURL=useLocale.js.map